module.exports = __webpack_public_path__ + "img/katarina12.236a62aa.jpg";